import { WebSocketReceiveWithSigningUserId } from './web-socket-receive-with-signing-user-id';
import type { Section } from '../../../menu/dto/section';

export class WebSocketReceiveReloadTemplateSection extends WebSocketReceiveWithSigningUserId {
  override payload: {
    SigningUserId: string;
    TemplateSectionId: string;
  };

  isAboutThis(section: Section): boolean {
    if (!section) return false;
    return section?.id === this.payload?.TemplateSectionId;
  }
}
